import { X } from 'lucide-react';

/* eslint-disable react/prop-types */
export default function ImageModal({ imageUrl, onClose }) {
  if (!imageUrl) return null;

  return (
    // 1. Full-screen overlay with a semi-transparent background
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80"
      onClick={onClose} // 2. Close modal when the overlay is clicked
    >
      {/* 3. Close button positioned at the top-right */}
      <button className="absolute top-4 right-4 text-white hover:text-gray-300" onClick={onClose}>
        <X size={32} />
      </button>

      {/* 4. Image container to prevent clicks on image from closing modal */}
      <div className="relative max-w-4xl max-h-[85vh] h-[85vh] ">
        <img
          onClick={(e) => e.stopPropagation()}
          src={imageUrl}
          alt="Enlarged view"
          className="object-contain w-auto h-full rounded-lg"
        />
      </div>
    </div>
  );
}
